import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxMasonryComponent } from 'ngx-masonry';
import { Carousel } from 'primeng/carousel';
import { ImageGalleryModalComponent } from 'src/app/shared/components/image-gallery-modal/image-gallery-modal.component';
import { ApiService } from 'src/app/shared/services';

@Component({
  selector: 'app-designer-profile',
  templateUrl: './designer-profile.component.html',
  styleUrls: ['./designer-profile.component.less']
})
export class DesignerProfileComponent implements OnInit {
  designerData: any;
  designerId: string;
  discountData: any;
  isHandset = false;
  responsiveOptions = [
    {
      breakpoint: '768px',
      numVisible: 1,
      numScroll: 1
    }
  ];

  emptyData = [1, 2, 3, 4];
  hideSticky: boolean;

  constructor(private apiService: ApiService, private snackbar: MatSnackBar, private router: Router,
    private matDialog: MatDialog,
    private actRouter: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.apiService.onInitLoaded = false;
    this.apiService.onInitLoadedMob = false;

    this.handleResize();

    this.designerId = this.actRouter.snapshot.params.designerId;
    this.getDesingerProfile();
    this.getDiscountData();
    this.getTestimonials();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.handleResize();
  }
  handleResize() {
    this.isHandset = window.innerWidth <= 800;
    if (!this.isHandset) {
      this.emptyData = [1, 2, 3, 4, 5, 6]
    }
    if (this.isHandset) {
      Carousel.prototype.onTouchMove = () => { };

      this.emptyData = [1]

    }

  }

  openGallery(data: any[], index: number): void {
    this.matDialog.open(ImageGalleryModalComponent, {
      data: { gallery: data.map(m => m.image), index: index },
      panelClass: 'full-screen-dialog',
      maxWidth: '100vw',
      height: '0',
      autoFocus: false,
      restoreFocus: false
    });
  }

  @ViewChild(NgxMasonryComponent) masonry!: NgxMasonryComponent;
  imageLoaded: boolean[] = [];


  onImageLoad(i: number) {
    this.imageLoaded[i] = true;

    setTimeout(() => {
      this.masonry.reloadItems();
      this.masonry.layout();
    });
  }



  // onImageError(index: number) {
  //   this.imageLoaded[index] = true;


  // }

  onImageError(event: Event, index: number): void {
    const img = event.target as HTMLImageElement;

    if (!img.src.includes('default_img.png')) {
      img.src = 'assets/image/default_img.png';
    }

    this.imageLoaded[index] = true;
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const offset = 190; // offset in pixels from bottom
    const scrollPosition = window.innerHeight + window.scrollY;
    const pageHeight = document.documentElement.scrollHeight;

    this.hideSticky = scrollPosition >= (pageHeight - offset);
  }
  getDiscountData() {
    this.apiService.getDiscountData().subscribe((res: any) => {
      if (res) {
        this.discountData = res;
      }
    })
  }
  get getDiscountAmount() {
    let discount = ((+this.discountData.design_book_amount) * (1 - ((+this.discountData.display_discount) / 100)));
    return Math.round(+discount);
  }
  testimonalList: any[] = [];
  getTestimonials() {
    this.apiService.getDesignTestimonials().subscribe((testimonials: any[]) => {
      this.testimonalList = testimonials.filter(f => f.designer_id?.toLowerCase() === this.designerId.toLowerCase());

      // this.testimonialToShow = testimonials[randomIdx];
    });
  }
  designerPortfolio: any[] = [];
  getDesingerProfile() {
    this.apiService.getDesignProfile(this.designerId).subscribe(
      res => {
        if (res[0]) {
          this.designerData = res[0];

          this.designerPortfolio = this.designerData.portfolio.map(img => ({
            image: img,
            hasError: false
          }));

          this.imageLoaded = new Array(this.designerPortfolio.length).fill(false);

          console.log('designer portfolio', this.designerPortfolio);
          setTimeout(() => {
            if (this.masonry) {
              this.masonry.reloadItems();
              this.masonry.layout();
            }
          });

          if (!this.designerData) {
            this.router.navigate(['/design']);
          }
        } else {
          this.snackbar.open('There is no designer data', 'Close', {
            duration: 3000
          });
        }
      },
      err => {
        this.snackbar.open(
          'Something went wrong, please try again later',
          'Close',
          { duration: 3000 }
        );
      }
    );
  }
  // getDesingerProfile() {
  //   this.apiService.getDesignProfile(this.designerId).subscribe(async res => {
  //     if (res[0]) {
  //       this.designerData = res[0];//.find(f => f.designerId?.toLowerCase() === this.designerId.toLowerCase());

  //       this.designerData['pf'] = this.designerData.portfolio.map(m=>({isImageAccessible:false, image:m}));
  //         const validatedPortfolio = await this.processPortfolioImages(this.designerData.pf);

  //         this.designerPortfolio = validatedPortfolio;
  //         console.log('designer portfolio', this.designerPortfolio);
  //       if (!this.designerData) {
  //         this.router.navigate(['/design']);

  //       }
  //     } else {
  //       this.snackbar.open('There is no designer data', 'Close', { duration: 3000 });
  //     }
  //   }, err => {
  //     this.snackbar.open('Something went wrong, please try again later', 'Close', { duration: 3000 });
  //   })
  // }
  // async processPortfolioImages(pf: any[]): Promise<any[]> {
  //     const validatedPortfolio = await Promise.all(
  //     pf.map(async (p) => {
  //       if (p.image) {
  //         p.isImageAccessible = await this.apiService.checkImageAccessible(
  //           p.image
  //         );
  //       }
  //       return p;
  //     })
  //   );

  //   return validatedPortfolio;
  // }

  openInsta() {
    window.open(this.designerData.social_ig, '_blank');
  }

  hideIntercomIcon() {
    const interval = setInterval(() => {
      const intercom = document.getElementsByClassName(
        "intercom-lightweight-app"
      )[0];
      if (intercom) {
        intercom.classList.add("dn");
        clearInterval(interval);
      }
    }, 500);

    const intervalx = setInterval(() => {
      const intercomx = document.getElementsByClassName("intercom-app")[0];
      if (intercomx) {
        intercomx.classList.add("dn");
        clearInterval(intervalx);
      }
    }, 500);
  }

  ngAfterViewInit(): void {
    this.hideIntercomIcon();
  }

  openStyleQuiz() {
    this.router.navigateByUrl(`/style-quiz?utm_designer=${this.designerData.designerId}`);


  }
}
